import { Component, effect, inject, ViewChild } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePicker, DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { UniqueIdService } from '../../../services/builder/unique-id.service';
import { WidgetService } from '../../../services/builder/widget.service';
import { baseCustomPanelStructureComponent } from '../../new-custom-panel/baseCustomPanelStructure';
import { DatePickerCustomization } from './datepicker-edit';

@Component({
  selector: 'lib-datepicker-custom-panel',
  template: `
    <lib-base-cpanel
      [content]="content"
      [form]="customizationForm"
      header="Personalizzazione Casella Data"
      (closed)="updateWidget($event)"
    />
    <ng-template #content>
      @if (customizationForm) {
        <div [formGroup]="customizationForm" class="flex flex-col gap-2">
          <div class="flex w-full flex-col">
            <label for="desc">Descrizione</label>
            <textarea
              id="desc"
              pTextarea
              formControlName="description"
            ></textarea>
          </div>
          <div class="p-fluid flex w-full flex-col">
            <label for="data">Valore predefinito</label>
            <p-datepicker
              [autofocus]="false"
              id="data"
              type="date"
              matInput
              formControlName="defaultValue"
              appendTo="body"
              [showOnFocus]="false"
              [iconDisplay]="'input'"
              [showIcon]="true"
              class="w-full"
              dateFormat="dd/mm/yy"
              [fluid]="true"
              #defaultDate
            />
          </div>
          <div class="flex w-full flex-row">
            <label for="required" class="w-full self-start">
              Campo obbligatorio
            </label>
            <p-checkbox
              id="required"
              formControlName="required"
              [binary]="true"
              class="self-end"
            ></p-checkbox>
          </div>
        </div>
      }
    </ng-template>
  `,
  imports: [
    ReactiveFormsModule,
    baseCustomPanelStructureComponent,
    InputTextModule,
    MatButtonModule,
    SelectModule,
    DatePickerModule,
    CheckboxModule,
    TextareaModule,
  ],
})
export class DatePickerCPanelComponent {
  private fb = inject(FormBuilder);
  protected widgetService = inject(WidgetService<DatePickerCustomization>);
  protected uniqueIdService = inject(UniqueIdService);

  protected customizationForm = this.fb.group({
    id: [
      '',
      [
        Validators.required,
        this.uniqueIdService.forbiddenIdValidator(
          this.widgetService.uniqueId ?? '',
        ),
        this.uniqueIdService.isEmptySpace(),
      ],
    ],
    description: [''],
    defaultValue: [null],
    required: [false],
    showIfRule: ['', [this.uniqueIdService.idNotExistsValidator()]],
    autocompleteRule: ['', [this.uniqueIdService.idNotExistsValidator()]],
    // topology: [0],
  });

  topologies = [
    {
      value: 0,
      viewValue: 'Normale',
    },
    {
      value: 1,
      viewValue: 'Con orario',
    },
    {
      value: 2,
      viewValue: 'Solo mese',
    },
    {
      value: 3,
      viewValue: 'Solo anno',
    },
  ];
  selectedTopology = 0;
  @ViewChild('defaultDate') calendar!: DatePicker;
  context = {};

  constructor() {
    effect(() => {
      const widget = this.widgetService.widget();
      if (!widget) return;

      const uniqueId = this.widgetService.uniqueId;
      if (!uniqueId) return;

      this.customizationForm?.patchValue({
        id: uniqueId,
        description: widget.customization.description,
        defaultValue: widget.customization.defaultValue,
        required: widget.customization.required,
        showIfRule: widget.customization.showIfRule,
        autocompleteRule: widget.customization.autocompleteRule,
        // topology: widget.customization.topology,
      });
    });
  }

  // ngAfterViewInit(): void {
  //   this.setTopology(
  //     this.form.dataForm.get('customization')?.get('topology')?.value,
  //   );
  //   this.form.dataForm
  //     .get('customization')
  //     ?.get('topology')
  //     ?.valueChanges.subscribe((val) => {
  //       this.setTopology(val);
  //     });
  // }

  // setTopology(val: number) {
  //   switch (val) {
  //     case 1:
  //       this.calendar.showTime = true;
  //       this.calendar.showSeconds = true;
  //       break;
  //     case 2:
  //       this.calendar.view = 'month';
  //       this.calendar.dateFormat = 'mm/yy';
  //       this.calendar.showTime = false;
  //       this.calendar.showSeconds = false;
  //       break;
  //     case 3:
  //       this.calendar.view = 'year';
  //       this.calendar.dateFormat = 'yy';
  //       this.calendar.showTime = false;
  //       this.calendar.showSeconds = false;
  //       break;
  //   }
  // }

  // dialogSavingFunction(res: any) {
  //   if (res) {
  //     if (res.customization.required === '') res.customization.required = false;

  //     if (res.customization.topology === '') res.customization.topology = 0;

  //     if (res.customization.defaultValue)
  //       res.customization.defaultValue = (
  //         res.customization.defaultValue as Date
  //       ).getTime();
  //   }
  //   return res;
  // }

  updateWidget(event: boolean) {
    if (!event) {
      this.widgetService.settingVisibility.set(false);
      return;
    }

    const formValue = this.customizationForm.value;
    const id = formValue.id?.trim();
    if (!id) return;

    this.widgetService.updateWidget(id, {
      description: formValue.description || '',
      defaultValue: formValue.defaultValue || null,
      required: formValue.required || false,
      showIfRule: formValue.showIfRule,
      autocompleteRule: formValue.autocompleteRule,
      // topology: this.customizationForm.value.topology || 0,
    });
    this.widgetService.settingVisibility.set(false);
  }
}
